/**
 * API Base Configuration
 * Single source of truth for API connection settings and environment-specific overrides.
 */

const PRODUCTION_API_URL =
  import.meta.env.VITE_API_BASE_URL || 'https://api.amalq.org';

export const API_CONFIG = {
  baseURL: PRODUCTION_API_URL,
  version: 'v1',
  timeout: 10000 as number
} as const;

/**
 * Returns environment-aware API configuration.
 * Production gets a longer timeout and retry budget; development keeps defaults.
 */
export const getApiConfig = (): Omit<typeof API_CONFIG, 'timeout'> & {
  retries: number;
  timeout: number;
} => {
  const env = import.meta.env as Record<string, string | undefined>;
  const isProduction = env?.PROD;

  return {
    ...API_CONFIG,
    timeout: isProduction ? 15000 : API_CONFIG.timeout,
    retries: isProduction ? 2 : 0
  };
};
